// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608051429/js/" + chunkId + "." + {"44":"67b89101","225":"57b7b823","481":"944a1b12","486":"508b21f9","770":"b91540f1"}[chunkId] + ".0.3635374584605692.chunk.js";
};